module.exports = __webpack_public_path__ + "92056817aedc835460eafd2b2a9f72eb.jpg";